import OriginalStatistic from './Statistic.svelte';
import Title from './Title.svelte';
import Value from './Value.svelte';
import Icon from './Icon.svelte';
import Goal from './Goal.svelte';
import OriginalComparison from './Comparison.svelte';
import ComparisonValue from './ComparisonValue.svelte';
import OriginalTrend from './Trend.svelte';
import TrendIcon from './TrendIcon.svelte';
const Statistic = OriginalStatistic;
Statistic.Icon = Icon;
Statistic.Title = Title;
Statistic.Value = Value;
Statistic.Goal = Goal;
Statistic.Comparison = OriginalComparison;
Statistic.Comparison.Value = ComparisonValue;
Statistic.Comparison.Trend = OriginalTrend;
Statistic.Comparison.Trend.Icon = TrendIcon;
export default Statistic;
